import { render, staticRenderFns } from "./AssuroAvatar.vue?vue&type=template&id=0b9530ee&scoped=true"
import script from "./AssuroAvatar.vue?vue&type=script&lang=ts"
export * from "./AssuroAvatar.vue?vue&type=script&lang=ts"
import style0 from "./AssuroAvatar.vue?vue&type=style&index=0&id=0b9530ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9530ee",
  null
  
)

export default component.exports